"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productViewLoad = void 0;
var getProductViewLoadEvent_1 = require("./getProductViewLoadEvent");
var productViewLoad = function (event) {
    return (0, getProductViewLoadEvent_1.getProductViewLoadEvent)(event);
};
exports.productViewLoad = productViewLoad;
